import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template"]
  static values = { insert: { type: String, default: "append" } }

  add(event) {
    event.preventDefault()
    const index = Date.now().toString()
    const fragment = this.templateTarget.content.cloneNode(true)
    const root = fragment.querySelector("[id*='NEW_RECORD']") || fragment.firstElementChild
    if (!root) return

    this.replaceNewRecordTokens(root, index)
    if (this.insertValue === "prepend") {
      this.listTarget.prepend(root)
    } else {
      this.listTarget.appendChild(root)
    }
  }

  replaceNewRecordTokens(root, index) {
    const attrs = ["name", "id", "for"]
    const visit = (el) => {
      attrs.forEach((attr) => {
        const v = el.getAttribute(attr)
        if (v && v.includes("NEW_RECORD")) {
          el.setAttribute(attr, v.replaceAll("NEW_RECORD", index))
        }
      })
    }
    visit(root)
    root.querySelectorAll("*").forEach(visit)
  }
}
